import script from "./EditorToolbarComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditorToolbarComponent.vue?vue&type=script&setup=true&lang=ts"

import "./EditorToolbarComponent.vue?vue&type=style&index=0&id=081bc502&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-081bc502"]])

export default __exports__